import AsyncStorage from "@react-native-async-storage/async-storage";

import type { OnboardingData } from "./types";
import {
  clearPartnerInvite,
  loadPartnerInvite,
  savePartnerInvite,
} from "./partnerInviteStorage";

const ONBOARDING_STORAGE_KEY = "@louise/onboarding_data";

export async function saveOnboardingData(data: OnboardingData): Promise<void> {
  const { partnerInvite, ...answers } = data;
  await AsyncStorage.setItem(
    ONBOARDING_STORAGE_KEY,
    JSON.stringify({ ...answers, partnerInvite: null }),
  );
  if (partnerInvite) {
    await savePartnerInvite(partnerInvite);
  } else {
    await clearPartnerInvite();
  }
}

export async function loadOnboardingData(): Promise<OnboardingData | null> {
  try {
    const stored = await AsyncStorage.getItem(ONBOARDING_STORAGE_KEY);
    const securePartnerInvite = await loadPartnerInvite();
    if (!stored) return null;

    const parsed = JSON.parse(stored) as OnboardingData;
    // Older builds could leave the opaque code in the general onboarding
    // blob without a trustworthy receivedAt timestamp. Remove that legacy
    // copy, but never refresh its TTL or resurrect it as an active invite.
    if (!securePartnerInvite && parsed.partnerInvite) {
      await AsyncStorage.setItem(
        ONBOARDING_STORAGE_KEY,
        JSON.stringify({ ...parsed, partnerInvite: null }),
      );
    }

    return {
      ...parsed,
      partnerInvite: securePartnerInvite ?? null,
    };
  } catch {
    return null;
  }
}

export async function clearOnboardingData(): Promise<void> {
  await AsyncStorage.removeItem(ONBOARDING_STORAGE_KEY);
  await clearPartnerInvite();
}
